"use strict";

var React = require('react');
var hoistNonReactStatics = require('hoist-non-react-statics');

module.exports = function executeLoadActions(ComposedComponent) {

  class ExecuteLoadActions extends React.Component {
		componentWillMount() {
			this.executeHandlerActions();
		}
		
		executeHandlerActions(props) {
			props = props || this.props;
			
			const actions = ComposedComponent.handlerActions || [];
			const location = Object.assign({}, props.location);
			const params = Object.assign({}, props.params);
			const dispatch = this.context.store.dispatch;
			
			[].concat(actions).forEach((action) => dispatch(action(location, params)));
		}

		componentWillReceiveProps(props) {
			this.executeHandlerActions(props);
		}
		
		render() {
			return <ComposedComponent {...this.props} />;
		}

	}

	ExecuteLoadActions.contextTypes = {
		store: React.PropTypes.object
	};

	ExecuteLoadActions.propTypes = {
		location: React.PropTypes.object.isRequired,
		params: React.PropTypes.object.isRequired
	};

	hoistNonReactStatics(ExecuteLoadActions, ComposedComponent);

	return ExecuteLoadActions;
};



/** WEBPACK FOOTER **
 ** ./app/addons/executeLoadActions.js
 **/